import { fetchPromotions } from "../http/postAPI";
import { PROMOTIONS_ROUTE } from "../utils/consts";
import { PostList } from "../components/Posts";

const PromotionsList = () => (
  <PostList
    title="Акции клиники"
    addLabel="акцию"
    route={PROMOTIONS_ROUTE}
    fetchData={fetchPromotions}
  />
);

export default PromotionsList;
